module.exports = __webpack_public_path__ + "img/guide_alipay.cc9bd75c.png";